import { Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import AuthorizedRepresentativeView from '~/components/views/authorizedRepresentative';
import theme from '~/constants/theme';
import { useGetApplication } from '~/controllers/wizard';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { getStagePayload } from '~/utils/getStagePayload';

const AuthorizedRepresentative: React.FC = () => {
  const ref = useRefScrollTo();
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const activeStep = stagePayload?.activeStep;

  return (
    <Container ref={ref}>
      <Typography.Title>{activeStep?.stepName}</Typography.Title>
      <AuthorizedRepresentativeView />
    </Container>
  );
};

const Container = styled.div`
  h4 {
    margin-bottom: 24px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    section {
      margin-top: 24px;
    }
  }
`;

export const getAuthorizedRepresentativeName = (index: number) => ['authorizedRepresentative', index];
export default AuthorizedRepresentative;
